import { render, staticRenderFns } from "./Renew.vue?vue&type=template&id=8b8cec6a&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"
import style0 from "./Renew.vue?vue&type=style&index=0&id=8b8cec6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8cec6a",
  null
  
)

export default component.exports